// Local Deps
import { makeGraphQLRequest } from '../../../utils/requestUtils';

export async function editInventory({
  id,
  niin,
  partNum,
  description,
  cage,
  price,
  ui,
  qup,
  soh,
  visibility,
  modifiedBy,
}) {


  // Format Mutation
  const query = `mutation updateInventory(
    $inventoryInput: EditInventoryInput
  ) {
     updateInventory(inventory:$inventoryInput)
      {
      status
      }
    }`;

  // Variables
  const variables = {
    inventoryInput: {
      id,
      niin,
      partNum,
      description,
      cage,
      price,
      ui,
      qup,
      soh,
      visibility,
      modifiedBy,
    },
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getCageCode(id) {
  const query = `query requestOrganizationById(
    $id: ID
  ) {
      organization(id: $id) {
        cageCode
      }
    }`;

  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}




// WEBPACK FOOTER //
// ./src/components/Modals/EditInventoryManagement/graphql.js